export const UserLoginDefaultData = {
    userName: "",
    password: ""
}